angular.module('mercury.layouts')
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('Budget', {
      templateUrl: 'layouts/layoutfullwidth.tpl.html',
      url: '/budget'
    });
    $stateProvider.state('Cashups', {
      templateUrl: 'layouts/layoutfullwidth.tpl.html',
      url: '/cashups'
    });
    $stateProvider.state('FullWidth', {
      templateUrl: 'layouts/layoutfullwidth.tpl.html'
    });
    $stateProvider.state('FullScreen', {
      templateUrl: 'layouts/layoutfullscreen.tpl.html'
    });
    $stateProvider.state('Reports', {
      templateUrl: 'layouts/layoutreports.tpl.html',
      url: '/reports'
    });
    $stateProvider.state('Settings', {
      // templateUrl: 'layouts/layoutmanage.tpl.html',
      templateUrl: 'layouts/layoutreports.tpl.html',
      url: '/settings'
    });
    $stateProvider.state('Support', {
      // templateUrl: 'layouts/layoutmanage.tpl.html',
      templateUrl: 'layouts/layoutreports.tpl.html',
      url: '/support'
    });
    $stateProvider.state('Stock', {
      // templateUrl: 'layouts/layoutmanage.tpl.html',
      templateUrl: 'layouts/layoutreports.tpl.html',
      url: '/stock'
    });
    $stateProvider.state('Time', {
      // templateUrl: 'layouts/layoutmanage.tpl.html',
      templateUrl: 'layouts/layoutreports.tpl.html',
      url: '/time',
      controller: ["$filter", "dialog", "$scope", "$state", "TimeRosteredShifts", "userinfo", "$window", function ($filter, dialog, $scope, $state, TimeRosteredShifts, userinfo, $window) {
        // If the target state is one of the Print roster states, stop the transition
        // and print the roster for the current week.
        $scope.$on('$stateChangeStart', function (event, toState) {
          if (toState.name == 'Time.RosterPrintByStaff' || toState.name == 'Time.RosterPrintByRole') {
            event.preventDefault();

            var print;

            // There is no $scope.viewStartDateTime here so have to find it manually
            // $state holds URL data, thus $state.params gets the query params
            var reportStart = $state.params.report
            // If the reportStart param is found then use that date otherwise use the current date 
            var momentReportStart = moment(reportStart ? JSON.parse(reportStart)['time'] : undefined).mStartOf('week')
            var reportStartFormatted = momentReportStart.format()
            var reportEndFormatted = momentReportStart.add(1, 'week').format()

            if (toState.name == 'Time.RosterPrintByStaff') {
              print = TimeRosteredShifts.printByStaff(reportStartFormatted, reportEndFormatted);
            } else {
              print = TimeRosteredShifts.printByRole(reportStartFormatted, reportEndFormatted);
            }

            print.then(function (result) {
              $window.location.assign(result.location);
            });
          }
        });
      }]
    });
    $stateProvider.state('Time.Payroll', {
      templateUrl: 'layouts/layoutempty.tpl.html',
      url: '/payroll'
    });
    $stateProvider.state('Time.Compliance', {
      templateUrl: 'layouts/layoutempty.tpl.html',
      url: '/compliance'
    });
  }]);
